const initializeCreateTopicModal = () => {
  const modalTriggerButton = document.getElementById("open-crate-topic-button");
  const modal = document.getElementById("bbp-create-topic-modal");
  const modalCloseButton = document.getElementById("close-crate-topic-button");

  if (modal && modalTriggerButton) {
    // open modal
    modalTriggerButton.addEventListener("click", (e) => {
      e.preventDefault();
      modal.showModal();
    });

    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal(modal);
      }
    });
  }

  if (modalCloseButton && modal) {
    modalCloseButton.addEventListener("click", (e) => {
      e.preventDefault();
      closeModal(modal);
    });
  }
};

const closeModal = (modal) => {
  modal.classList.add("modalClosed");
  setTimeout(() => {
    modal.close();
    modal.classList.remove("modalClosed");
  }, 200);
};

if (document.readyState !== "loading") {
  initializeCreateTopicModal();
} else {
  document.addEventListener("DOMContentLoaded", initializeCreateTopicModal);
}
